import { NotificationManager } from "react-notifications";

// Two rules for every toast on the site (hundreds of old calls, so it's done here once):
// 1. Technical sign-in errors never reach a reader: the "Please sign in again" sheet handles those.
// 2. The same message within 3 seconds shows once.
const SIGN_IN_NOISE = /token is invalid or expired|did not provide a token/i;
const recent = new Map();

["info", "success", "warning", "error"].forEach((kind) => {
  const original = NotificationManager[kind].bind(NotificationManager);
  NotificationManager[kind] = (message, ...rest) => {
    const text = String(message == null ? "" : message);
    if (SIGN_IN_NOISE.test(text)) return undefined;
    const key = `${kind}:${text}`;
    const now = Date.now();
    if (now - (recent.get(key) || 0) < 3000) return undefined;
    recent.set(key, now);
    return original(message, ...rest);
  };
});
